export default "__VITE_ASSET__DPT1IEFB__"